export { id, id as password } from './id';
export { num, num as int } from './number';
export { float } from './float';
export { bool, bool as boolean } from './boolean';
export { thumb, thumb as thumbnail } from './thumbnail';
export { user } from './user';
export { image } from './image';
export { lorem, lorem as text } from './lorem';
export { avatar, avatar as ava } from './avatar';



// WEBPACK FOOTER //
// src/index.ts